module.exports = __webpack_public_path__ + "static/media/attentionPlayIcon.ef2c32cd.svg";